import { useEffect, useMemo, useState } from "react";
import { ordenar } from "../lib/agrupar";
import CabecalhoCmv from "./CabecalhoCmv";
import LinhaProduto from "./LinhaProduto";
import Paginacao from "./Paginacao";

/** Lista corrida de produtos, paginada — a visão antiga, útil para achar o pior produto da loja toda. */
export default function TabelaProdutos({ linhas, sort, onSort }) {
  const [porPagina, setPorPagina] = useState(10);
  const [pagina, setPagina] = useState(1);
  const ordenadas = useMemo(() => ordenar(linhas, sort), [linhas, sort]);
  const totalPaginas = Math.max(1, Math.ceil(ordenadas.length / porPagina));
  const atual = Math.min(Math.max(1, pagina), totalPaginas);

  useEffect(() => setPagina(1), [linhas, sort, porPagina]);

  const inicio = (atual - 1) * porPagina;
  return (
    <>
      <table className="w-full text-sm">
        <CabecalhoCmv sort={sort} onSort={onSort} />
        <tbody>
          {ordenadas.slice(inicio, inicio + porPagina).map((p) => <LinhaProduto key={p.id} p={p} />)}
        </tbody>
      </table>
      <Paginacao total={ordenadas.length} pagina={atual} porPagina={porPagina} onPagina={setPagina} onPorPagina={setPorPagina} />
    </>
  );
}
